import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { Tabs, Tab, TABS_JUSTIFY } from '../Tabs/index'
import DetailPageV3Title from './DetailPageV3Title'
import DetailPageV3Description from './DetailPageV3Description'
import DetailPageV3ActionBar from './DetailPageV3ActionBar'
import DetailPageV3InfoMetaItems from './DetailPageV3InfoMetaItems'
import DetailPageV3InfoMeta from './DetailPageV3InfoMeta'
import DetailPageV3Related from './DetailPageV3Related'
import DetailPageV3ActionButtons from './DetailPageV3ActionButtons/DetailPageV3ActionButtons'
import DetailPageV3ActionCopyLink from './DetailPageV3ActionButtons/DetailPageV3ActionCopyLink'
import DetailPageV3ActionPlaylist from './DetailPageV3ActionButtons/DetailPageV3ActionPlaylist'
import DetailPageV3ActionVote from './DetailPageV3ActionButtons/DetailPageV3ActionVote'
import DetailPageV3Info from './DetailPageV3Info'
import DetailPageV3SeriesEpisodes from './DetailPageV3SeriesEpisodes'
import DetailPageV3CommentsView from './DetailPageV3CommentsView'
import DetailPageV3TopModule from './DetailPageV3TopModule'

const DetailPageV3Series = (props) => {
  const {
    detailData = Map(),
    staticText,
    location,
    history,
    apolloClient,
    uiLocation,
  } = props

  const ga4EventData = {
    content_name: detailData.get('title'),
    content_id: detailData.get('contentId'),
    content_type: detailData.get('contentType'),
    ui_location: uiLocation,
  }

  return (
    <div className="detail-page-v3 detail-page-v3--series">
      <DetailPageV3TopModule
        detailData={detailData}
        location={location}
        history={history}
        apolloClient={apolloClient}
        ga4EventData={ga4EventData}
      />
      <div className="detail-page-v3__content">
        <div className="detail-page-v3__layout-wrapper">
          <DetailPageV3Title
            title={detailData.get('title')}
            moreButtonLabel={staticText.get('moreInfo')}
            mobilePopupTitle={staticText.get('description')}
            moreContent={
              <>
                <DetailPageV3Description description={detailData.get('description')} />
                <DetailPageV3InfoMeta detailData={detailData} />
              </>
            }
          />

          <DetailPageV3ActionBar
            metaItems={
              <DetailPageV3InfoMetaItems detailData={detailData} isInline={false} />
            }
            actionButtons={
              <DetailPageV3ActionButtons
                primaryButtons={
                  <>
                    <DetailPageV3ActionVote
                      detailData={detailData}
                      ga4EventData={ga4EventData}
                    />
                    <DetailPageV3ActionCopyLink
                      detailData={detailData}
                    />
                  </>
                }
                hiddenButtons={
                  <>
                    <DetailPageV3ActionPlaylist
                      detailData={detailData}
                      ga4EventData={ga4EventData}
                    />
                  </>
                }
              />
            }
          />

          <Tabs
            justify={TABS_JUSTIFY.LEFT}
            activeTab={0}
          >
            <Tab key={0} label={staticText.get('overview')}>
              <DetailPageV3Info
                text={detailData.get('description')}
                moreButtonLabel={staticText.get('moreInfo')}
              >
                <>
                  <DetailPageV3Description description={detailData.get('description')} />
                  <DetailPageV3InfoMeta detailData={detailData} />
                </>
              </DetailPageV3Info>

              <div id="commentsBlock"></div>
              <DetailPageV3CommentsView
                title={staticText.get('comments')}
                moreButtonLabel={`${staticText.get('viewAllComments')}`}
                detailData={detailData}
              />
            </Tab>
            <Tab key={1} label={`${staticText.get('seasonsAndEpisodes')} (${detailData.get('seasonsCount')})`}>
              <DetailPageV3SeriesEpisodes detailData={detailData} uiLocation={uiLocation} />
            </Tab>
            <Tab key={2} label={`${staticText.get('related')}`}>
              <DetailPageV3Related detailData={detailData.get('featuredContent')} isSeries />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3Series)
